import { Box, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import TabPanel from "../components/TabPanel";
import TodayWeather from "../components/TodayWeather";
import LocationSearchTextBox from "../components/LocationSearchTextBox";
import TomorrowWeather from "../components/TomorrowWeather";
import SevenDaysWeather from "../components/SevenDaysWeather";
import LeftDrawer from "../components/LeftDrawer";
import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { DEFAULT_BACKGROUND_COLOR, weatherCodes } from "../types/Weather";
import { getDateOnlyString } from "../helpers/weather-helpers";


const Main = () => {
  const [tabNum, setTabNum] = useState(0);
  const { currentWeather, hourlyWeatherMap } = useLocationWeatherContext();
  const [bgGradient, setBgGradient] = useState(DEFAULT_BACKGROUND_COLOR);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabNum(newValue);
  };

  useEffect(() => {
    const todayDateStr = getDateOnlyString(currentWeather?.time)
    const todayHourlyWeather = hourlyWeatherMap.get(todayDateStr ?? "");

    if (!todayHourlyWeather) {
      return;
    }

    const weatherCode = weatherCodes.get(todayHourlyWeather[0].weathercode);
    if (currentWeather?.is_day) {
      setBgGradient(weatherCode?.dayBgColor!);
    }
    else {
      setBgGradient(weatherCode?.nightBgColor!);
    }
  }, [currentWeather?.time, currentWeather?.is_day, hourlyWeatherMap]);

  return (
    <Box sx={{ background: bgGradient, paddingBottom: 2, minHeight: '100vh' }}>
      <Grid container sx={{ paddingLeft: 4 }} alignItems="center">
        <Grid item sx={{ width: '50px' }}>
          <LeftDrawer />
        </Grid>
        <Grid item xs>
          <LocationSearchTextBox />
        </Grid>
      </Grid>
      <Box display={{ xs: 'none', md: 'block' }} sx={{ px: 4 }}>
        <Grid container spacing={2}>
          <Grid item md={4} sx={{ textAlign: "center" }}>
            <Typography sx={{ mb: 2 }} variant="h4">Today</Typography>
            <TodayWeather />
          </Grid>
          <Grid item md={4} sx={{ textAlign: "center" }}>
            <Typography sx={{ mb: 2 }} variant="h4">Tomorrow</Typography>
            <TomorrowWeather />
          </Grid>
          <Grid item md={4} sx={{ textAlign: "center" }}>
            <Typography sx={{ mb: 2 }} variant="h4">7 Days</Typography>
            <SevenDaysWeather />
          </Grid>
        </Grid>
      </Box>
      <Box display={{ xs: 'block', md: 'none' }}>
        <Box sx={{ pt: 2 }}>
          <Grid container spacing={2} >
            <Grid xs display="flex" justifyContent="center" alignItems="center">
              <Tabs value={tabNum} onChange={handleChange} centered textColor="inherit">
                <Tab label="Today" />
                <Tab label="Tomorrow" />
                <Tab label="7 days" />
              </Tabs>
            </Grid>
          </Grid >
        </Box>
        <Box
          sx={{ pt: 3, pb: 2, pl: 4, pr: 4 }} >
          <TabPanel value={tabNum} index={0}>
            <TodayWeather />
          </TabPanel>
          <TabPanel value={tabNum} index={1}>
            <TomorrowWeather />
          </TabPanel>
          <TabPanel value={tabNum} index={2}>
            <SevenDaysWeather />
          </TabPanel>
        </Box>
      </Box>
    </Box>
  );
}

export default Main;